"use strict";
var menuIcon = document.querySelector(".top-bar__icon");
var closeIcon = document.querySelector(".sidebar__close");
var sidebar = document.querySelector(".sidebar");
var menuLink = document.querySelectorAll(".menu__item a");
menuIcon.addEventListener("click", function() {
    sidebar.classList.add("sidebar--active");
    document.body.classList.add("no-scroll");
});
closeIcon.addEventListener("click", function() {
    sidebar.classList.remove("sidebar--active");
    document.body.classList.remove("no-scroll");
});
menuLink.forEach(function(link) {
    link.addEventListener("click", function() {
        sidebar.classList.remove("sidebar--active");
        document.body.classList.remove("no-scroll");
    });
});
var arrow = document.querySelector(".footer__totop");
/* eslint-disable no-undef */ function smoothScrollToTop() {
    var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 500;
    var start = window.pageYOffset;
    var startTime = performance.now();
    function scrollStep(currentTime) {
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var ease = 1 - Math.pow(1 - progress, 3);
        window.scrollTo(0, start * (1 - ease));
        if (progress < 1) requestAnimationFrame(scrollStep);
    }
    requestAnimationFrame(scrollStep);
}
/* eslint-enable no-undef */ arrow.addEventListener("click", function() {
    smoothScrollToTop(500);
});
var form = document.querySelector(".form");
form.addEventListener("submit", function(event) {
    event.preventDefault();
    this.reset();
});

//# sourceMappingURL=index.e9f75d25.js.map
